import React from 'react'

import { useAsyncMemo, useDataLayer } from '@agnostack/lib-utils-react'
import { ensureObject, getData } from '@agnostack/lib-core'
import { DATALAYER } from '@agnostack/lib-utils-js'

import { MODAL_TYPES, TITLE_SCHEDULE_DEMO } from '../../../util'

import StatefulModal from '../StatefulModal'

const { HUBSPOT_CONTACT_PROPERTIES_EMAIL, HUBSPOT_CONTACT } = DATALAYER

// eslint-disable-next-line prefer-destructuring
const GATSBY_GTM_ID = process.env.GATSBY_GTM_ID // NOTE: combined these fails at runtime in gatsby

const ScheduleModal = ({ id, baseUrl: _baseUrl }) => {
  const [customerEmail] = useDataLayer(GATSBY_GTM_ID, HUBSPOT_CONTACT_PROPERTIES_EMAIL)
  const [contact] = useDataLayer(GATSBY_GTM_ID, HUBSPOT_CONTACT)
  const {
    // id: contactId, // NOTE: may wantto add this
    properties: {
      firstname,
      lastname,
    } = {},
  } = ensureObject(contact)

  const meetingUrl = useAsyncMemo(async () => {
    try {
      let baseUrl = _baseUrl
      if (!baseUrl) {
        const { DEFAULT: defaultBaseUrl } = await getData('calendarsData')
        baseUrl = defaultBaseUrl
      }

      if (!baseUrl) {
        return undefined
      }

      const _meetingUrl = new URL(baseUrl)
      if (customerEmail) {
        _meetingUrl.searchParams.append('email', customerEmail)
      }
      if (firstname) {
        _meetingUrl.searchParams.append('firstname', firstname)
      }
      if (lastname) {
        _meetingUrl.searchParams.append('lastname', lastname)
      }

      return _meetingUrl.href
    } catch {
      return undefined
    }
  }, [_baseUrl, firstname, lastname, customerEmail])

  if (!meetingUrl) {
    return null
  }

  return (
    <StatefulModal
      id={id}
      title={TITLE_SCHEDULE_DEMO}
      type={MODAL_TYPES.IFRAME}
      url={meetingUrl}
      // NOTE: this is the color of the BG in HubSpot (can see when scrolling)
      background="rgb(245, 248, 250)"
    />
  )
}

export default ScheduleModal
